import React from 'react';

import {Icon, Text} from '@albert-io/atomic';

import {ActionCard} from '../cards/ActionCard';
import {CleverImportCard} from '../cards/CleverImportCard';
import {useCleverUser} from '../hooks/useCleverUser';
import {useNewClassroomModal} from '../hooks/useNewClassroomModal';

/** Has-classes classroom management: Clever re-sync (when eligible) + create classroom. */
export const ClassroomManagement = () => {
  const {user, showClever} = useCleverUser();
  const {openNewClassroom, newClassroomModal} = useNewClassroomModal();

  return (
    <section aria-label='Classroom Management' className='gap-x2 flex flex-col'>
      <Text>Classroom Management</Text>
      <div className='gap-x2 s:grid-cols-[2fr_1fr] grid grid-cols-1'>
        {showClever && user ? <CleverImportCard user={user} /> : null}
        <ActionCard
          data-testid='home-action__create-class'
          horizontal
          iconClassName='background-kiwi-subtle content-kiwi'
          iconContent={<Icon color='inherit' icon='chalkboard' iconStyle='light' size='inherit' />}
          onClick={openNewClassroom}
          title='Create a class'
        />
      </div>
      {newClassroomModal}
    </section>
  );
};
